import React from 'react';
import { StyledMe2onBalance } from './style';
import { formattingNumber } from 'utils';
import { Me2onBalanceProps } from './types';

const Me2onBalance = ({
  balance,
  balanceQuantityFormat,
  playerLevelImg,
}: Me2onBalanceProps) => {
  return (
    <StyledMe2onBalance>
      <div className="imgContainer">
        <img className="balanceImg" alt="balance" src={balance.image} />
      </div>
      <span>
        {balanceQuantityFormat
          ? formattingNumber(
              balance.amount,
              balanceQuantityFormat,
              false,
              100,
              false,
              true,
            )
          : balance.amount}
      </span>
      {playerLevelImg && (
        <img
          src={playerLevelImg}
          alt="playerLevelImg"
          className="playerLevelImg"
        />
      )}
    </StyledMe2onBalance>
  );
};

export default Me2onBalance;
